import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { User } from 'STORE/Users/User/User';

interface IMemberItemProps {
  getIsSelected(member: User): boolean;
  toggleMember(member: User): void;
  member: User;
}

export const MemberItem: FC<IMemberItemProps> = observer(
  ({ getIsSelected, toggleMember, member }) => {
    const isSelected = getIsSelected(member);

    const classes = classNames(popupItemStyles.smallContainer, popupItemStyles.interactive, {
      [popupItemStyles.active]: isSelected,
    });

    return (
      <div
        className={classes}
        onClick={(): void => toggleMember(member)}
      >
        <PopupInfoCard
          type={AvatarTypes.Round_0}
          avatarTitle={member.avatarTitle}
          avatarUrl={member.avatarUrl || undefined}
          avatarBackgroundColorIndex={member.avatarColorIndex}
          title={member.displayName}
          subtitle={member.email}
        />
      </div>
    );
  }
);
